import React, { useState } from "react";
import { toast } from "react-toastify";
import { USER_DELETION_REASONS } from "../../../constants";

export default function FormDeleteUser({ onSubmitForm, onCancel }) {

  const [selectedReason, setSelectedReason] = useState("");
  const [otherReason, setOtherReason] = useState("");

  const handleReasonChange = event => {
    setSelectedReason(event.target.value);
    if (event.target.value !== "Outro:") {
      setOtherReason("");
    }
  };

  const handleOtherReasonChange = event => {
    setOtherReason(event.target.value);
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleSubmit = event => {
    event.preventDefault();

    let finalReason = selectedReason;
    if (selectedReason === "Outro:") {
      finalReason = otherReason;
    }

    if (!finalReason) {
      toast.warn("Por favor, selecione ou informe um motivo de exclusão.");
      return;
    }

    onSubmitForm(finalReason);
  };

  return (
    <form onSubmit={handleSubmit}>
      <label className="form-label">Informe o motivo da exclusão:</label>
      {Object.entries(USER_DELETION_REASONS).map(([key, text]) => (
        <div className="ml-5" key={key}>
          <label className="form-label cursor-pointer">
            <input
              type="radio"
              name="reason"
              className="form-check-input cursor-pointer"
              value={text}
              checked={selectedReason === text}
              onChange={handleReasonChange}
            />
            {text}
          </label>
        </div>
      ))}

      {selectedReason === USER_DELETION_REASONS.OTHER  && (
        <div>
          <label htmlFor="otherReasonInput">Detalhe a razão:</label>
          <input
            type="text"
            id="otherReasonInput"
            className="form-control"
            value={otherReason}
            onChange={handleOtherReasonChange}
            placeholder="Digite o motivo aqui..."
            maxLength={255}
            minLength={15}
            required
          />
        </div>
      )}
      <div className="d-flex justify-content-end gap-2 mt-4">
        <button type="button" className="btn btn-light" onClick={handleCancel}>
          Cancelar
        </button>
        <button type="submit" className="btn btn-danger font-weight-bold ml-5">
          Deletar usuário
        </button>
      </div>
    </form>
  );
}
